import { useProfileSettingsCache } from "utils/context/ProfileSettingsContext";
import { PERMISSIONS } from "utils/data/enum";

function useGlobal() {
  const [{ profileSettings }] = useProfileSettingsCache();
  const permissionCodes = profileSettings?.userPermissionItemTypes as string[];
  console.log("profileSettings:", profileSettings);

  const checkIfPermissionIsAssigned = (
    permissions: PERMISSIONS[] | undefined
  ) => {
    if (permissions && permissions.length > 0) {
      for (let permission of permissions) {
        // TODO - remove userID check  - rlo 5/19/2026
        const allowTheseUsers = [
          // DEV
          '49f499eb-c2ae-4aef-9ebf-37c5c38e0133', // robun 
          '46B3186B-84D4-4A29-8171-E201F86217E3', // hong 
          '0E30EBF4-BB08-4452-B58A-F0917BBEA9A2' // caroline 
        ];
        if (permissionCodes?.includes(permission) || allowTheseUsers.includes(profileSettings.userID) ) {
          return true;
        }
      }
    }
    return false;
  };

  return { checkIfPermissionIsAssigned };
}

export default useGlobal;
